import { cloneDeep } from 'lodash';
import {
  RESET_ANALYSIS_SECTION,
  SET_ANALYSIS_ACTIVE_LAYER,
  SET_ANALYSIS_ACTIVE_ABSTRACT_TYPE,
  SET_ANALYSIS_EVENTS,
  SET_ANALYSIS_EVENTS_SORTING,
  SET_ANALYSIS_GROUP_PARTICIPATIONS,
  SET_ANALYSIS_IS_PROCESSING,
  SET_ANALYSIS_LAYERS,
  SET_ANALYSIS_LAYERS_SORTING,
  SET_ANALYSIS_MODES,
  SET_ANALYSIS_PARTICIPATIONS,
  SET_ANALYSIS_PROCESSING_STEP,
  SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET,
  SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI,
  SET_ANALYSIS_SIGNALS,
  SET_ANALYSIS_SIGNALS_COLORS,
  SET_ANALYSIS_SIGNALS_SORTING,
  SET_ANALYSIS_STIMULI,
  SET_ANALYSIS_STIMULI_SORTING,
  SET_ANALYSIS_VISIBLE_LAYERS,
  SET_ANALYSIS_SIGNAL_DIMENSIONS_SORTING,
  SET_PROJECT_EXPORTS,
  SET_ANNOTATION_LIST,
} from './consts';
import { SET_ANALYSIS_ACTIVE_STIMULI } from './stimuliActions';
import { SET_ANALYSIS_ACTIVE_EVENT } from './eventsActions';

/* Analysis modes */
const analysisModes = [
  {
    id: 'heatMap',
    label: 'Heat Map',
    selected: true
  },
  {
    id: 'dataExportation',
    label: 'Data Exportation',
    selected: false
  },
  {
    id: 'journeyMap',
    label: 'Participant Journey Map',
    selected: false
  },
  {
    id: 'aggregateJourneyMap',
    label: 'Aggregate Journey Map',
    selected: false
  },
  {
    id: 'circumplex',
    label: 'Circumplex',
    selected: false
  },
  {
    id: 'video',
    label: 'Video',
    selected: false
  }
];

const appInitialState = {
  section: null,
  layers: [],
  visibleLayerIds: [],
  activeLayerId: null,
  layersSorting: [],
  signalsColors: {},
  participations: [],
  groupParticipations: [],
  annotations: [],

  signals: [],
  stimuli: [],
  events: [],
  exports: [],

  signalsSorting: {},
  signalDimensionsSorting: {},
  stimuliSorting: {},
  eventsSorting: {},

  activeAbstractTypeId: null,
  activeAbstractType: null,
  selectedStimuliId: null,
  activeStimuliId: null,
  activeEventId: null,

  listeningLayers: false,
  listeningProcessLayer: false,
  analysisModes,
  chartsData: null,
  isProcessing: false,
  processingStep: null
};

const singleAnalysisReducer = (state = appInitialState, action) => {
  switch (action.type) {
    case SET_ANALYSIS_LAYERS:
      return { ...state, layers: action.layers };
    case SET_ANALYSIS_IS_PROCESSING:
      return { ...state, isProcessing: action.isProcessing };
    case SET_ANALYSIS_PROCESSING_STEP:
      return { ...state, processingStep: action.processingStep };
    case SET_ANALYSIS_ACTIVE_LAYER:
      return {
        ...state,
        activeLayerId: action.activeLayerId,
        activeSignalId: null,
        activeStimuliId: null,
        activeEventId: null
      };
    case SET_ANALYSIS_VISIBLE_LAYERS:
      return { ...state, visibleLayerIds: action.visibleLayerIds };
    case SET_ANALYSIS_LAYERS_SORTING:
      return { ...state, layersSorting: action.layersSorting };
    case SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI:
      return { ...state, selectedStimuliId: action.selectedStimuliId };

    case SET_ANALYSIS_SIGNALS_SORTING:
      return { ...state, signalsSorting: action.signalsSorting };
    case SET_ANALYSIS_SIGNAL_DIMENSIONS_SORTING:
      return { ...state, signalDimensionsSorting: action.signalDimensionsSorting };
    case SET_ANALYSIS_STIMULI_SORTING:
      return { ...state, stimuliSorting: action.stimuliSorting };
    case SET_ANALYSIS_EVENTS_SORTING:
      return { ...state, eventsSorting: action.eventsSorting };

    case SET_ANALYSIS_SIGNALS:
      return { ...state, signals: action.signals };
    case SET_ANALYSIS_STIMULI:
      return { ...state, stimuli: action.stimuli };
    case SET_ANALYSIS_EVENTS:
      return { ...state, events: action.events };

    case SET_ANALYSIS_ACTIVE_ABSTRACT_TYPE:
      return {
        ...state,
        activeAbstractTypeId: action.activeAbstractTypeId,
        activeAbstractType: action.activeAbstractType
      };
    case SET_ANALYSIS_ACTIVE_STIMULI:
      return { ...state, activeStimuliId: action.activeStimuliId };
    case SET_ANALYSIS_ACTIVE_EVENT:
      return { ...state, activeEventId: action.activeEventId };

    case SET_ANALYSIS_SIGNALS_COLORS:
      return { ...state, signalsColors: action.signalsColors };
    case SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET:
      return { ...state, listeningLayers: action.listeningLayers };
    case SET_ANALYSIS_PARTICIPATIONS:
      return { ...state, participations: action.participations };
    case SET_ANALYSIS_GROUP_PARTICIPATIONS:
      return { ...state, groupParticipations: action.groupParticipations };
    case RESET_ANALYSIS_SECTION:
      return cloneDeep(appInitialState);
    case SET_ANALYSIS_MODES:
      return { ...state, analysisModes: action.analysisModes };
    case SET_PROJECT_EXPORTS:
      return { ...state, exports: action.exports };

    case SET_ANNOTATION_LIST:
      return { ...state, annotations: action.list };
    default:
      return state;
  }
};

export default singleAnalysisReducer;



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/reducer.js